import { render, staticRenderFns } from "./CouponCampaign.vue?vue&type=template&id=6aa9024c&scoped=true"
import script from "./CouponCampaign.vue?vue&type=script&lang=js"
export * from "./CouponCampaign.vue?vue&type=script&lang=js"
import style0 from "./CouponCampaign.vue?vue&type=style&index=0&id=6aa9024c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa9024c",
  null
  
)

export default component.exports